import { PHASE_STATE, PHASES } from '@/store/availableActions/utils/const';
import { isPhaseInState } from '@/store/availableActions/utils/event';

export function isEventInDiscovering(eventPhases) {
  return isPhaseInState(eventPhases, PHASES.HUNT, PHASE_STATE.IS_IN_PROGRESS) && isPhaseInState(eventPhases, PHASES.JOBFAIR, PHASE_STATE.IS_UPCOMING)
}